import { combineReducers } from 'redux';
import { cloneDeep } from 'lodash';

import {
	FETCH_DATA_SUCCESS,
	TOGGLE_CIRCLES,
	TOGGLE_CIRCLE,
	CLEAR_FILTERS,
	SET_FILTERED_CIRCLES,
	LOGOUT_USER,
	CLOSE_DROPDOWNS,
} from '../types';

const toggleCircle = (state, payload) => {
	const { id, selected } = payload;

	return {
		...state,
		[id]: { ...state[id], selected  }
	}
}

const deselectAllCircles = state => {
	const newCircles = cloneDeep(state);

	Object.entries(newCircles).forEach(([key, value]) => {
		value.selected = false;
	});
	return newCircles;
}

const byId = (state = {}, action) => {
	switch (action.type) {
		case FETCH_DATA_SUCCESS:
			return {
				...state,
				...action.payload.files.entities.circles,
			}

		case TOGGLE_CIRCLE:
			return toggleCircle(state, action.payload);

		case CLEAR_FILTERS:
			return deselectAllCircles(state);

		case LOGOUT_USER:
			return {}

		default:
			return state;
	}
}

const allIds = (state = [], action) => {
	switch (action.type) {
		case FETCH_DATA_SUCCESS:
			const keys = Object.keys(action.payload.files.entities.circles);
			return keys.map(Number);

		case LOGOUT_USER:
			return []

		default:
			return state;
	}
}

const filteredIds = (state = [], action) => {
	switch (action.type) {
		case FETCH_DATA_SUCCESS:
			const keys = Object.keys(action.payload.files.entities.circles);
			return keys.map(Number);

		case SET_FILTERED_CIRCLES:
			return action.payload

		
		case CLEAR_FILTERS:
			return action.payload.circles

		case LOGOUT_USER:
			return []

		default:
			return state;
	}
}

const metaInitialState = {
	active: false,
}

const meta = (state = metaInitialState, action) => {
	switch (action.type) {
		case TOGGLE_CIRCLES:
			return {
				...state,
				active: !state.active,
			}
		
		case CLEAR_FILTERS:
			return {
				...state,
				active: false,
			}

		case LOGOUT_USER:
			return metaInitialState;

		case CLOSE_DROPDOWNS:
			return metaInitialState;
			
		default:
			return state;
	}
}

const circles = combineReducers({
	byId,
	allIds,
	filteredIds,
	meta,
});
export default circles;

export const getIsActive = state => state.meta.active;
export const getIds = state => state.allIds;
export const getFilteredIds = state => state.filteredIds;
export const getCircles = state => {
	const ids = getFilteredIds(state);
	const circles = ids.map(id => state.byId[id]);

	return circles.sort((a, b) => {
		var textA = a.title.toUpperCase();
		var textB = b.title.toUpperCase();
		return (textA < textB) ? -1 : (textA > textB) ? 1 : 0;
	});
}
export const getSelectedCircles = state => {
	const ids = getIds(state);
	return ids.filter(id => state.byId[id].selected);
}


// WEBPACK FOOTER //
// ./src/store/circles/reducer.js